import { useEffect, useRef } from 'react';

/** Closes the active editor menu with Escape while keeping the latest callback stable. */
const useEscapeToClose = (active, onClose) => {
  const onCloseRef = useRef(onClose);

  useEffect(() => {
    onCloseRef.current = onClose;
  }, [onClose]);

  useEffect(() => {
    if (!active) return undefined;

    const handleEscape = (event) => {
      if (event.key !== 'Escape') return;

      event.preventDefault();
      event.stopPropagation();
      onCloseRef.current?.();
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [active]);
};

export default useEscapeToClose;
